import { render, staticRenderFns } from "./AddOrEdit.vue?vue&type=template&id=4a6f1c7f&"
import script from "./AddOrEdit.vue?vue&type=script&lang=js&"
export * from "./AddOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports